var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleXIconFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19C8.75 19 7.58 18.764 6.49 18.292C5.39933 17.8193 4.44767 17.177 3.635 16.365C2.823 15.5523 2.18067 14.6007 1.708 13.51C1.236 12.42 1 11.25 1 10C1 8.75 1.236 7.57633 1.708 6.479C2.18067 5.38167 2.823 4.427 3.635 3.615C4.44767 2.80233 5.39933 2.16333 6.49 1.698C7.58 1.23267 8.75 1 10 1C11.25 1 12.4237 1.23267 13.521 1.698C14.6183 2.16333 15.573 2.80233 16.385 3.615C17.1977 4.427 17.8367 5.38167 18.302 6.479C18.7673 7.57633 19 8.75 19 10C19 11.25 18.7673 12.42 18.302 13.51C17.8367 14.6007 17.1977 15.5523 16.385 16.365C15.573 17.177 14.6183 17.8193 13.521 18.292C12.4237 18.764 11.25 19 10 19ZM6.979 14.604L10 11.583L13.021 14.604L14.625 13L11.604 10L14.625 6.979L13.021 5.375L10 8.396L6.979 5.375L5.396 6.958L8.417 10L5.396 13.021L6.979 14.604Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleXIconFilled);
export default __webpack_public_path__ + "static/media/circleXIconFilled.c6c7d1b5fcab5441a6f6254d33277a0f.svg";
export { ForwardRef as ReactComponent };